module.exports = __webpack_public_path__ + "assets/6e3550ed4af4efef477b2d82bdce5ccd.svg";